module.exports = __webpack_public_path__ + "img/invoice-management.48cf4aa1.png";